import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import {
  setCurrentUser,
  setAuthHeader,
  setPriviledge
} from 'redux/authentication/auth.actions';
import ProgressBar from 'common-components/ProgressBar';
import { getCredential } from '../../api';
import { useAuth } from '../../useAuth';
import Alert from 'common-components/Alert';

import '../../login.style.css';

const AzureLogin = ({ history, location, setCurrentUser, setPriviledge, setAuthHeader }) => {
  const { search } = location;
  const auth = useAuth();
  const [alertData, setAlertData] = useState({});

  const requestAzureLogin = async (query) => {
    const parsedQuery = new URLSearchParams(query);
    const stored_session_state = localStorage.getItem('__AZURE_STATE__');
    const prevUrl = localStorage.getItem('__PREV_PATH__');
    const urlAfterLogout = localStorage.getItem('__PATH_AFTER_LOGOUT__');

    const payload = {
      code: parsedQuery.get('code'),
      state: parsedQuery.get('state'),
      session_state: parsedQuery.get('session_state'),
      stored_session_state: stored_session_state,
    }

    let response = await getCredential(payload);
    if (response) response = JSON.parse(response);
    else {
      setAlertData({
        title: 'Login Failed',
        description: 'Got server error. Kindly contact WPV team',
        eventName: 'Close',
        showModal: true,
        type: 'error'
      });
      return;
    }

    setCurrentUser(response.name);
    setAuthHeader(response.token);
    setPriviledge({
      is_reviewer: response.is_reviewer,
      is_admin: response.is_admin,
      is_other: response.is_other,
    });

    auth.signIn(response.token);
    localStorage.setItem('__TOKEN__', response.token);
    localStorage.removeItem('__AZURE_STATE__');
    localStorage.removeItem('__PREV_PATH__');
    localStorage.removeItem('__PATH_AFTER_LOGOUT__');
    history.push(urlAfterLogout || prevUrl || '/home');
  };

  useEffect(() => {
    if (search) {
      requestAzureLogin(search)
    }
  }, [search]);

  return (
    <>
      <Alert
        showModal={alertData.showModal}
        setShowModal={setAlertData}
        data={alertData}
      />
      <div className='progress-bar-container'>
        < ProgressBar
          done='100'
          timeout='2000'
          message='Logging in. .'
        />
      </div>
    </>
  )

};

const mapStateToProps = ({
  authentication: { pageBeforeLogin } }) => ({
    pageBeforeLogin
  });

const mapDispatchToProps = dispatch => ({
  setCurrentUser: user => dispatch(setCurrentUser(user)),
  setAuthHeader: token => dispatch(setAuthHeader(token)),
  setPriviledge: priviledge => dispatch(setPriviledge(priviledge)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AzureLogin);

